import type { SalesChecklistItemDefaultExample } from "@expert/contentful";

import { useDetectedCuesStore } from "@/sales-tools/detected-cues/stores/DetectedCuesStore";
import { CarouselWithDefault } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/CarouselWithDefault";
import { getDetectedDeviceExamples } from "@/sales-tools/home-product/components/FullOfferChecklist/utils/getDetectedDeviceExamples";
import { useProductOfferStore } from "@/sales-tools/home-product/stores";
import { useLanguageStore } from "@/sales-tools/language-selector/useLanguageStore";
import { useSessionId } from "@/sdk";

export function CoverageCarousel({ defaultExample }: { defaultExample: SalesChecklistItemDefaultExample }) {
    const { getPrimaryProducts, getProductInfo } = useProductOfferStore.getState();
    const sessionId = useSessionId();
    const devices = useDetectedCuesStore((state) => state.getDisplayCues(sessionId));
    const primaryProductSku = getPrimaryProducts(sessionId).at(0)?.productSku;
    const languageState = useLanguageStore();
    const coverageResponses =
        getProductInfo(sessionId, primaryProductSku, languageState.language)?.personalizedCoverage ?? [];
    const examples = getDetectedDeviceExamples(devices, coverageResponses);

    return <CarouselWithDefault defaultExample={defaultExample} examples={examples} />;
}
